import * as types from './constants';

// Get Analytics Campaign Modifiers
export const getAnalyticsCampaignModifiersRequest = data => (
  { type: types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_REQUEST, payload: data }
);

export const getAnalyticsCampaignModifiersDone = data => (
  { type: types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_DONE, payload: data }
);

export const getAnalyticsCampaignModifiersFailed = errors => (
  { type: types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_FAILED, payload: errors }
);

export const getAnalyticsCampaignModifiersReset = () => (
  { type: types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_RESET }
);

export const analyticsCampaignModifiersSetPage = data => (
  { type: types.ANALYTICS_CAMPAIGN_MODIFIERS_SET_PAGE, payload: data }
);